<script setup>
import { Icon, Toggle, IconsGroup } from "@components";

import { useRoute, useRouter } from "vue-router";
const route = useRoute();
const router = useRouter();

import { useCustomizer } from "@store/customizer";
const $customizer = useCustomizer();

import { useSettings } from "@store/settings";
import { computed } from "vue";
const $settings = useSettings();

const props = defineProps({
  serial: {
    type: [Number, String],
  },
  menu: {
    type: Object,
    default: {},
  },
  totalMenu: {
    type: Number,
  },
  menuIndex: {
    type: Number,
  },
  draggable: {
    type: Boolean,
    default: true,
  },
});

// const toggleVisibilityIcon = (id) => {
//     event.preventDefault()

//     $customizer.sidebarFormMenu.find(menu => menu.id == id).visible = !props.menu?.visible
// }

const updateSelected = (parentId, childrenId) => {
  // update selected
  $settings.customizer[parentId][childrenId] = $customizer.getMenuStatusById(
    parentId,
    childrenId
  );

  // enable staff show details when show image is true
  if (
    parentId == "staff" &&
    childrenId == "show_image" &&
    $customizer.getMenuStatusById(parentId, childrenId) == true
  ) {
    // enable from prebook_admin
    $settings.customizer["staff"]["show_details"] = true;

    // enable & selected from state
    $customizer.sidebarFormMenu
      .find((menu) => menu.id == "staff")
      .children.find((menu) => menu.id == "show_details").disabled = false;
    $customizer.sidebarFormMenu
      .find((menu) => menu.id == "staff")
      .children.find((menu) => menu.id == "show_details").selected = true;
  }

  // disable staff show details when show image is false
  if (
    parentId == "staff" &&
    childrenId == "show_image" &&
    $customizer.getMenuStatusById(parentId, childrenId) == false
  ) {
    // disable from prebook_admin
    $settings.customizer["staff"]["show_details"] = false;

    // disable & selected from state
    $customizer.sidebarFormMenu
      .find((menu) => menu.id == "staff")
      .children.find((menu) => menu.id == "show_details").disabled = true;
    $customizer.sidebarFormMenu
      .find((menu) => menu.id == "staff")
      .children.find((menu) => menu.id == "show_details").selected = false;
  }
};

const handleClick = (event) => {
  if (route.name == props.menu?.link?.name) return event.preventDefault();

  router.push({ name: props.menu?.link?.name, query: { ...route.query } });
};
console.log(props);
console.log(props.draggable);
</script>

<template>
  <div>
    <!-- <hr class="border-[#F2F4F7]" v-if="props.menuIndex !== 0"> -->
    <!-- <hr class="border-[#F2F4F7] transition-all" v-if="props.menu?.link.name !== route.name && props.menuIndex !== 0"> -->
    <hr class="border-[#F2F4F7] transition-all" />

    <div
      @click="handleClick"
      :to="props.menu?.link"
      class="cursor-pointer group rounded-md my-3 py-2 px-3 flex items-center justify-between gap-2 text-[#344054] hover:text-[#101828] hover:bg-[#F2F4F7] transition-all duration-200"
      :class="{
        'bg-[#F2F4F7]': route.name == props.menu?.link?.name,
        '': route.name == props.menu?.link?.name || props.menuIndex == 0,
      }"
    >
      <div class="flex items-center gap-3">
        <Icon
          name="dotsMove"
          size="20px"
          class="text-[#98A2B3] hidden transition duration-[2s]"
          :class="{ 'block group-hover:block': props.draggable }"
        />
        <div
          :class="[
            { 'group-hover:hidden': props.draggable },
            props.serial ? 'block' : 'hidden',
          ]"
          class="text-white text-sm font-medium rounded-full w-5 h-5 flex items-center justify-center bg-[#7F56D9] transition duration-500"
        >
          {{ props.serial }}
        </div>
        <div class="text-lg font-semibold capitalize">
          {{ props.menu?.title }}
        </div>
      </div>
      <!-- <Icon @click="toggleVisibilityIcon(props.menu.id)" :name="props.menu?.visible ? 'eye' : 'eyeOff'" size="24px" class="text-[#98A2B3] hidden group-hover:block" :class="{ '!block': props.menu?.link?.name == route.name }" /> -->
    </div>

    <!-- sub menu -->
    <div
      class="ml-11 mr-4"
      :class="{ 'mb-5': props.menu?.children?.length }"
      v-if="route.name == props.menu?.link?.name"
    >
      <template v-for="sub in props.menu?.children" :key="sub.title">
        <div
          v-if="sub.visible === undefined || sub.visible"
          class="flex justify-between items-center gap-2.5 text-sm font-medium text-[#101828] mb-4 last:mb-0 capitalize"
        >
          {{ sub.title }}

          <IconsGroup
            v-if="sub.component == 'IconsGroup'"
            v-model="sub.selected"
            :options="sub.options"
            @change="updateSelected(props.menu.id, sub.id)"
          />
          <Toggle
            v-if="sub.component == 'Toggle'"
            v-model="sub.selected"
            @change="updateSelected(props.menu.id, sub.id)"
            :disabled="sub.disabled"
          ></Toggle>
        </div>
      </template>
    </div>

    <hr
      class="border-[#F2F4F7] transition-all"
      v-if="props.menuIndex == props.totalMenu - 1"
    />
  </div>
</template>
